<template>
  <BbSelectList
    v-model="selectedValue"
    :label="fieldConfig.name"
    :placeholder="fieldConfig.placeholder"
    :class="[
      'filters-dropdown',
      { 'filters-selected-item': selectedValue },
      { 'filters-dropdown-unexpanded': !expandedFilters },
    ]"
    size="small"
    @click="setExpandedFilters(true)"
  >
    <BbSelectListItem
      v-for="(item, index) in fieldConfig.optionList"
      v-show="!item.isDeprecated"
      :key="index"
      :label="item.label"
      :value="item.value"
      size="small"
    >
      <div class="list-item">
        <span>{{ item.label }}</span>
        <span v-if="item.subtitle">{{ item.subtitle }}</span>
      </div>
    </BbSelectListItem>
  </BbSelectList>
</template>

<script>
import { computed } from 'vue';

export default {
  props: {
    fieldConfig: {
      type: Object,
      default: () => {},
      required: true,
    },
    values: {
      type: Object,
      default: () => {},
      required: true,
    },
    expandedFilters: {
      type: Boolean,
      default: false,
    },
    setExpandedFilters: {
      type: Function,
      default: () => {},
    },
  },

  setup(props, { emit }) {
    const selectedValue = computed({
      get: () => props.values[props.fieldConfig.id],
      set: (val) => emit('change', { value: val, id: props.fieldConfig.id }),
    });

    return {
      selectedValue,
    };
  },
};
</script>

<style scoped lang="scss">
.filters-selected-item {
  :deep(.el-select__placeholder::before) {
    content: url('@/assets/svg/selected-check.svg');
    padding: 6px 8px 0 0;
  }
}

.filters-dropdown:first-of-type {
  :deep(.el-select__wrapper) {
    border-top-left-radius: 50px;
    border-bottom-left-radius: 50px;
  }
}

.filters-dropdown {
  width: 100% !important;

  :deep(.bb-select-list__label) {
    position: absolute;
    top: 16px;
    left: 16px;
    z-index: 1;
    font-size: 15px;
    color: $bb-neutral-2;
  }

  :deep(.el-select) {
    width: 100% !important;
  }

  :deep(.el-select__wrapper) {
    background: $bb-neutral-5;
    border-radius: 0;
    height: 68px;
    border: 0 !important;
  }

  :deep(.el-select__wrapper.is-focused) {
    background: $bb-neutral-0 !important;
    border-radius: 50px;
    border: 1px solid $bb-neutral-4 !important;
    box-shadow: 0px 4.923px 7.876px 0px rgba(0, 0, 0, 0.1) !important;
  }

  :deep(.el-select__wrapper.is-hovering) {
    border: unset !important;
  }

  :deep(.el-select__placeholder) {
    color: $bb-neutral-1 !important;
    font-weight: 500;
    font-size: 15px;
    margin-top: 9px;
    margin-left: 7px;
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
  }

  :deep(.el-select__suffix) {
    display: none;
  }

  :deep(.el-popper) {
    border: 1px solid $bb-neutral-4 !important;
  }

  :deep(.bb-select-list__dropdown) {
    border-radius: 24px !important;
    padding: 8px 0 !important;
  }

  :deep(.el-select-dropdown__item) {
    border-bottom: unset !important;
    padding: 8px 24px;
  }

  :deep(.list-item) {
    display: flex;
    flex-direction: column;
  }

  :deep(.bb-select-list-item) {
    height: 60px !important;
    font-style: unset !important;
    line-height: unset !important;
    font-size: 15px;
    color: #1a1a1a;
    font-width: 400;
  }

  :deep(.list-item span:first-child) {
    font-weight: 600;
  }
}

.filters-dropdown-unexpanded {
  :deep(.el-select__wrapper) {
    background: $bb-neutral-0;
    height: 34px !important;
  }

  :deep(.bb-select-list__label) {
    display: none;
  }

  :deep(.el-select__placeholder) {
    margin-top: 0;
  }
}
</style>
